export enum MandateType {
  RiskCategory = 'riskCategory',
  PerformanceFixedRate = 'performanceFixedRate',
  GoalDuration = 'goalDuration',
  Volatility = 'volatility',
  MaximumDrawdown = 'maximumDrawdown'
}
